import React from "react";
import Typewriter from "typewriter-effect";

function TypeWriter() {
  return (
    <div
      className="typewriter-wrapper"
      style={{ display: "block", whiteSpace: "normal", overflowWrap: "break-word", fontSize: "1.05rem" }}
    >
      <Typewriter
        options={{
          strings: [
            "Full Stack JavaScript Developer",
            "React, Next.js & Vue.js Specialist",
            "Node.js & Express Backend Developer",
            "React Native Mobile App Builder",
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 50,
        }}
      />
    </div>
  );
}

export default TypeWriter;
